import React from "react";
import Container from "react-bootstrap/Container";
import "@fortawesome/fontawesome-svg-core/styles.css";
import LegoL99EData from "../legosRefactored-24/dataDriven/LegoL99EData";
import preSurgicalNutritionCards from "../legosRefactored-24/dataDriven/preSurgicalNutritionCards";
import { pdf2026, thumb2026 } from "../legosRefactored-24/dataDriven/assets";

const nourishBowlPdf = pdf2026("Pre-Surgical Nutrition", "How to Make a Nourish Bowl.pdf");
const nourishBowlThumb = thumb2026("Pre-Surgical Nourish Bowl.jpg");

const LivingWellCenter4_1_PreSurgical = () => {
  return (
    <div>
      <div className="w-100 legosNewBuild livingWellCenterHeader">
        <section className="mb-0">
          {/* L6 Background image header bar */}
          <div className="lego l006 legoMargin5">
            <div
              className="backgroundImage"
              style={{
                backgroundImage:
                  "url(" +
                  "https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/0d445c7f791eb836ce7a12e72e3003b1.jpeg" +
                  ")",
                backgroundPosition: "80% 0%",
              }}
            >
              <div
                className="transparentBarTypeContainer"
                style={{
                  backgroundColor: "#FA4E36",
                }}
              >
                &nbsp;&nbsp;
              </div>
              <h2 className="l6SubheadWithBackground">Pre-Surgical Nutrition</h2>
            </div>
          </div>
          {/* End L6 Background image header bar */}
        </section>
        <Container>
          <div className="w-100">
            <div className="col-12 m-auto">
              <div className="whiteBackground floatLeft clearLeft legosNewBuild livingWellCenterHeader">
                <section>
                  {/* L10A Bold Lead In */}
                  <div className="lego l00paragraph">
                    <p>
                      <span className="boldLeadInNewUI">
                        Successful joint replacement surgery or spine surgery
                        begins before you enter the operating room.
                      </span>
                    </p>
                  </div>
                  {/* End L10A Bold Lead In */}

                  {/* L14 Paragraph */}
                  <div className="lego l00paragraph legoMargin5">
                    <p>
                      The WashU Medicine Living Well Center helps you prepare
                      for surgery by focusing on lifestyle habits that can
                      support your successful preparation going into your
                      surgery and during your recovery, including the key topic
                      of Pre-Surgical Nutrition.
                    </p>
                  </div>
                  {/* End L14 Paragraph */}

                  {/* L99 Resource and Description New - Nourish Bowl (featured) */}
                  <div className="lego l099 legoMargin5">
                    <div className="legoContainer">
                      <div className="imgContainer">
                        <a target="_blank" rel="noreferrer" href={nourishBowlPdf}>
                          <img
                            className=""
                            alt="How to Make a Nourish Bowl"
                            src={nourishBowlThumb}
                          />
                        </a>
                      </div>
                      <div className="contentContainer">
                        <p className="descriptionHeader">How to Make a Nourish Bowl</p>
                        <p>
                          Nourish bowls are a simple way to assemble a meal
                          utilizing already prepared food or ingredients you
                          have in your pantry. A mix of dark leafy greens,
                          protein, complex carbohydrates, vegetables, and
                          healthy fats will provide you with energy and help you
                          feel fuller for longer. Try different herbs, spices
                          and sauces to add variety throughout the week.
                        </p>
                        <p>
                          Click image or{" "}
                          <a
                            target="_blank"
                            rel="noreferrer"
                            className="blueLinkfont"
                            href={nourishBowlPdf}
                          >
                            this link
                          </a>{" "}
                          to view.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* End L99 Resource and Description New - Nourish Bowl (featured) */}

                  {/* L99E Data - 3-up resource row */}
                  <LegoL99EData cards={preSurgicalNutritionCards} legoMargin="legoMargin5" />
                  {/* End L99E Data */}

                  {/* L28 Back To Top */}
                  <div className="lego l028 backToTop">
                    <div className="w-100">
                      <p>
                        <a
                          className="specialUseBackToTop"
                          onClick={() =>
                            window.scrollTo({ top: 0, behavior: "smooth" })
                          }
                        >
                          BACK TO TOP{" "}
                        </a>
                      </p>
                    </div>
                  </div>
                  {/* End L28 Back To Top */}
                </section>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default LivingWellCenter4_1_PreSurgical;
